import React from 'react';
import { Section } from './ui/Section';
import { Gift, Wind, Sparkles, Feather, Utensils, Zap, ShieldPlus, HeartPulse, Moon, Baby, Archive } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: <Wind className="w-5 h-5 text-[#C9963A]" data-id="element-23" />,
    title: 'Aromaterapia Fácil en 7 Minutos',
    desc: 'Aprende a crear desde cero aceites esenciales naturales.'
  }, {
    icon: <Sparkles className="w-5 h-5 text-[#C9963A]" data-id="element-24" />,
    title: 'Baños Mágicos y Sahumerios',
    desc: 'Guía completa de limpieza y rituales ancestrales.'
  }, {
    icon: <Feather className="w-5 h-5 text-[#C9963A]" data-id="element-25" />,
    title: 'Belleza Herbal: Piel, Pelo y Manos',
    desc: 'Recetas naturales para tu rutina de belleza.'
  }, {
    icon: <Utensils className="w-5 h-5 text-[#C9963A]" data-id="element-26" />,
    title: 'Cocina Limpia en 10 Minutos',
    desc: 'Comidas sanas y naturales listas en 10 minutos.'
  }, {
    icon: <Zap className="w-5 h-5 text-[#C9963A]" data-id="element-27" />,
    title: 'Protocolo Express por Síntoma',
    desc: 'Guía rápida de: Me pasa esto → Hago esto.'
  }, {
    icon: <ShieldPlus className="w-5 h-5 text-[#C9963A]" data-id="element-28" />,
    title: 'Kit de Urgencias Naturales',
    desc: '10 remedios express que salvan en 5 minutos.'
  }, {
    icon: <HeartPulse className="w-5 h-5 text-[#C9963A]" data-id="element-29" />,
    title: 'SOS 7 Días Anti Inflamación',
    desc: 'Menú completo para desinflamar tu cuerpo en una semana.'
  }, {
    icon: <Moon className="w-5 h-5 text-[#C9963A]" data-id="element-30" />,
    title: 'Guía Herbal para la Mujer Radiante',
    desc: 'Equilibrio cíclico y bienestar en la etapa de menopausia.'
  }, {
    icon: <Baby className="w-5 h-5 text-[#C9963A]" data-id="element-31" />,
    title: 'Botiquín Natural Infantil',
    desc: 'Uso responsable y seguro para tus hijos y nietos.'
  }, {
    icon: <Archive className="w-5 h-5 text-[#C9963A]" data-id="element-32" />,
    title: 'Conservá tus Hierbas',
    desc: 'Cómo conservar tu stock todo el año.'
  }];
  return <Section background="white" data-id="element-33">
      <div className="text-center mb-8" data-id="element-34">
        <div className="inline-flex items-center gap-2 bg-[#1B4332] text-white px-4 py-1 rounded-full text-sm font-medium mb-4" data-id="element-35">
          <Gift className="w-4 h-4" data-id="element-36" />
          Regalos Exclusivos
        </div>
        <h2 className="text-3xl md:text-4xl mb-3" data-id="element-37">
          Con tu compra, te llevás 10 bonos de regalo
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-38">
          Cada bono fue diseñado para complementar tu botiquín y darte más
          herramientas.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-39">
        {bonuses.map((bonus, i) => <div key={i} className="bg-[#FDF8F0] p-4 rounded-xl border border-[#1B4332]/10 flex items-start gap-4 relative overflow-hidden group hover:border-[#C9963A]/30 transition-colors" data-id="element-40">
            <div className="bg-white p-2.5 rounded-full shadow-sm flex-shrink-0 mt-1" data-id="element-41">
              {bonus.icon}
            </div>
            <div data-id="element-42">
              <h3 className="font-bold text-[#1B4332] text-lg leading-tight mb-1" data-id="element-43">
                {bonus.title}
              </h3>
              <p className="text-sm text-gray-600 leading-snug" data-id="element-44">{bonus.desc}</p>
            </div>

            {/* Badge */}
            <div className="absolute top-0 right-0 bg-[#1B4332]/5 text-[#1B4332] text-[10px] font-bold px-2 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-45">
              Incluido
            </div>
          </div>)}
      </div>
    </Section>;
}